import React, {useState} from 'react';
import PropTypes from 'prop-types';
import '../../../../members/client-member-list.css';
import ConnectedMembers from "./ConnectedMembers";
import NotConnectedMembers from "./NotConnectedMembers";
import Translate from "../../../../../../../../components/Translate";
import {memberSupportsClient} from "../../../../../../../../utils/General";
import Tabs from "../../../../../../../../components-new/ui/Tabs";

const ClientMemberList = ({
                              members,
                              client,
                              addMembersToClient,
                              removeMembersFromClient,
                              skills,
                              user,
                              tariff
                          }) => {

    const [activeTab, setActiveTab] = useState('connectedMembers');

    const connectedMembers = members.filter((member) => memberSupportsClient(member, client));
    const notConnectedMembers = members.filter((member) => !memberSupportsClient(member, client));

    const tabs = [
        {
            label: "connectedMembers",
            value: "connectedMembers",
            count: connectedMembers.length
        },
        {
            label: "notConnectedMembers",
            value: "notConnectedMembers",
            count: notConnectedMembers.length
        }
    ];

    return (
        <React.Fragment>

            <div>
                <Tabs
                    selectedTab={activeTab}
                    onTabChange={setActiveTab}
                    tabs={tabs}
                    renderTab={tab => (
                        <React.Fragment>
                            <Translate text={tab.label}/>
                        </React.Fragment>
                    )}
                />
            </div>

            <div className="bg-white" style={{minHeight: '0', padding: 0}}>
                {activeTab === 'connectedMembers' && (
                    <ConnectedMembers tariff={tariff} user={user} skills={skills} client={client}
                                      connectedMembers={connectedMembers}
                                      removeMembersFromClient={removeMembersFromClient}/>
                )}

                {activeTab === 'notConnectedMembers' && (
                    <NotConnectedMembers client={client} notConnectedMembers={notConnectedMembers}
                                         addMembersToClient={addMembersToClient}/>
                )}
            </div>

        </React.Fragment>
    );
};

ClientMemberList.propTypes = {
    members: PropTypes.array.isRequired,
    client: PropTypes.object.isRequired,
    addMembersToClient: PropTypes.func.isRequired,
    removeMembersFromClient: PropTypes.func.isRequired,
    skills: PropTypes.array,
    user: PropTypes.object,
    tariff: PropTypes.object
};

export default ClientMemberList;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/clients/new/operators/components/ClientMemberList.jsx